import { ColorModeContext, useMode } from "../Theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Sidebars from "../ui-components/global/Sidebar";
import React from "react";
//import Changepassword from "./Security/Changepassword";
import Listview from "./pages/Listview";
import { useParams } from "react-router-dom";
import Productdetail from "./pages/Inventory/Productdetail";
import Editmaterialcategory from "./pages/Inventory/Editmaterialcategory";
import Editproductcategory from "./pages/Inventory/Editproductcategory";
import Imageupload from "./pages/Imageupload";
import Chartboard from "./pages/Chart";
import Editcustomermaster from "./pages/Masters/Editcustomermaster";
// import Editbom from './pages/Masters/Editbom';
import Editsupplymaster from "./pages/Masters/Editsupplymaster";
import Editprocess from "./pages/Masters/Editprocess";
import Editemployee from "./pages/HR/Editemployees";
import Edituom from "./pages/Masters/Edituoms";
import Edituomconversion from "./pages/Masters/Edituomconversion";
import Editdept from "./pages/HR/Editdept";
import Edittaxmaster from "./pages/Masters/Edittaxmaster";
import Editcurrency from "./pages/Masters/Editcurrency";
import Editcolorshades from "./pages/Masters/Editcolorshades";
import Editcountry from "./pages/Masters/Editcountry";
import Editleathermaster from "./pages/Masters/Editleathermaster";
import Editairlines from "./pages/Masters/Editairlines";
import Editproformainvoice from "./pages/Trascation/Editproformainvoice";
import Editmatrial from "./pages/Inventory/Editmaterial";
import ListviewSecondary from "./pages/Secondarylistview";
import Editdesignpattern from "./pages/Masters/Editdesignpattern";
import Editremarks from "./pages/Masters/Editremarks";
import Editindentorder from "./pages/Inventory/Editindentorder";
import Editdeliverychalan from "./pages/Masters/Editdeliverychalan";
import Editcustomerorder from "./pages/Masters/Editcustomerorder";
import Editgrade from "./pages/Masters/Editgrade";
import Editsubstance from "./pages/Masters/Editsubstance";
import Editopeningstock from "./pages/Masters/Editopeningstock";
import Editcompany from "./pages/Masters/Editcompany";
import Editbankmasters from "./pages/Masters/Editbankmasters";
import Editissue from "./pages/Masters/Editissue";
import NotFound from "./Security/NotFound";
import Editstock from "./pages/Masters/Editstock";
import Bomproduct from "./pages/Inventory/Bom";
import Editproductstock from "./pages/Masters/Editproductstock";
import Editbatch from "./pages/Inventory/Editbatch";
import Editbatchcompletion from "./pages/Inventory/Editbatchcompletion";
import Editbatchissue from "./pages/Inventory/Editbatchissue";
import Editworkingprocess from "./pages/Trascation/Editworkinprocess";
import TimeLine from "./pages/Trascation/Timeline";
import Editindcoutdc from "./pages/Masters/Editoutdcindc";
import { MyProSidebarProvider } from "../ui-components/global/sideBarContext";
import Editlocalinvoce from "./pages/Trascation/Editlocalinvoce";
import Editpackinglist from "./pages/Trascation/Editpackinglist";
import Editpacking from "./pages/Trascation/Editpacking";
import Editproduct from "./pages/Inventory/Editproduct";
import Editfinance from "./pages/FinanceModule/Editfinance";
import Editoverhead from "./pages/FinanceModule/Editoverhead";
import Editcosting from "./pages/FinanceModule/Editcosting";
import Edituser from "./pages/security1/Edituser";
import Editusergroup from "./pages/security1/Editusergroup";
import EditHsn from "./pages/Masters/EditHsn";
import Editreport from "./pages/Masters/Editreport";
import Editpurchaseindent from "./pages/Masters/Editpurchaseindent";
import Editproducttracking from "./pages/Masters/Editproducttracking";
import Editproduction from "./pages/Masters/Editproduction";
import Editcustomerlinechart from "./pages/Masters/Editcustomerlinechart";

import Editassorted from "./pages/Trascation/Editassorted";
import ProductAnalysis from "./pages/Trascation/ProductAlaysis";
import Editcolor from "./pages/Masters/Editcolor";
import Editcolorcustomer from "./pages/Masters/Editcolorcustomer";
import Editbom from "./pages/Inventory/Editbom";
import Editfunction from "./pages/HR/Editfunction";
import Editdesignation from "./pages/HR/Editdesignation";
import Editcheckin from "./pages/Empolyee/Editchechin";
import Editcheckout from "./pages/Empolyee/Editcheckout";
import Editlocation from "./pages/Masters/Editlocation";
import Editgate from "./pages/Masters/Editgate";
import Editbin from "./pages/Masters/Editbin";
import Editproject from "./pages/HR/Editproject";
import EditDailytask from "./pages/Empolyee/Editdailytask";
import EditDailyHourstask from "./pages/Empolyee/EditDailyHourTask";
import Editfixedassettype from "./pages/FinanceModule/Editfixedassettype";
import Editfixedassetcategory from "./pages/FinanceModule/Editfixedassetcategory";
import Editfixedasset from "./pages/FinanceModule/Editfixedasset";
import EditEmpCheckin from "./pages/Empolyee/EditEmpCheckin";
import EditEmpCheckout from "./pages/Empolyee/EditEmpCheckout";
import Editstockcare from "./pages/Inventory/Editstockcare";
import Editpriceofothercustomer from "./pages/FinanceModule/Editpriceofothercustomer";
import EditEmpfinance from "./pages/Empolyee/EditEmpfinance";
import Editpostshipment from "./pages/Trascation/Editpostshipment";
import Editjobworkcategory from "./pages/Inventory/Editjobworkcategory";
import EditJobwork from "./pages/Inventory/EditJobwork";
import Editinspection from "./pages/Inventory/Editinspection";
import Editpurchaseorder from "./pages/FinanceModule/Editpurchaseorder";
import Editpurchaseorderopen from "./pages/FinanceModule/Editpurchaseorderopen";
import { PDFViewer } from "@react-pdf/renderer";
import MyDocument from "./pages/pdf/pdf";
import EditPurchaseOrderParameter from "./pages/Masters/EditrPurchaseOrderParameter";
// import Editcostingnew from "./pages/FinanceModule/Editproductcosting";
import EditSalaryComponent from "./pages/Empolyee/EditSalaryComponent";
import EditSatuaryComponent from "./pages/Empolyee/EditSatuaryComponent";
import EditemployeePayroll from "./pages/Empolyee/EditemployeePayroll";
import Editrunpayroll from "./pages/Empolyee/Editrunpayroll";
import LeaveType from "./pages/HR/Editleavetype";
import Holidaylist from "./pages/HR/Editholidaylist";
import Regularization from "./pages/Empolyee/EditRegularization";
import EditRole from "./pages/HR/Editrole";
import EditMilestones from "./pages/HR/Editmilestone";
import Editmajortask from "./pages/HR/Editactivities";
import Logopage from "../assets/Logopage";
import Editoperation from "./pages/HR/Editoperationstage";
import EditActivities from "./pages/HR/Editactivities";
import Edittask from "./pages/HR/EditTask";
import EditmileWeightage from "./pages/HR/Editweightage";
import Settings from "./Security/Settings";
import Editvendor from "./pages/HR/Editvendor";
import Configuration from "./Security/Configuration";
import Changepass from "./Security/Changepassword";
import Editrequests from "./pages/Empolyee/Editrequest";
import Editapprovals from "./pages/Empolyee/EditApproval";
import EditSprint from "./pages/HR/EditSprint";
import EditAttendance from "./pages/Empolyee/EditAttendance";
import EditAttendanceHistory from "./pages/Empolyee/EditAttendaceHistory";
import EditTimeSheet from "./pages/Empolyee/EditTimeSheet";
import EditTimeDailytask from "./pages/Empolyee/EditTimeDailyTask";
import Editshift from "./pages/HR/Editshift";
import Edittimesheetreport from "./pages/Empolyee/Edittimesheetreport";
import EditdailyAttendance from "./pages/Empolyee/EditDailyattendance";
import Biometricconfiguration from "./Security/Biometric";
import Geoconfiguration from "./Security/Geoconfig";
import Approval from "./Security/Approval";
import EditContractsin from "./pages/HR/ContractsIN";
import EditContractsout from "./pages/HR/ContractsOut";
import SkillGlowList from "./pages/SkillGlow/SkillGlowList";
import SkillSession from "./pages/SkillGlow/SkillSession";
import SkillCategory from "./pages/SkillGlow/SkillCategory";
import CreateSkill from "./pages/SkillGlow/CreateSkill";
import CreateCategory from "./pages/SkillGlow/CreateCategory";
import QuestionList from "./pages/SkillGlow/QuestionList";
import CreateQuestion from "./pages/SkillGlow/CreateQuestion";
import CandidateList from "./pages/SkillGlow/CandidateList";
import CreateCandidates from "./pages/SkillGlow/CreateCandidates";
import CreateSession from "./pages/SkillGlow/CreateSession";
import QuestionDetails from "./pages/SkillGlow/QuestionDetails";
import CategoryMain from "./pages/SkillGlow/CategoryMain";
import CreateCategoryMain from "./pages/SkillGlow/CreateCategoryMain";
import CandidateMain from "./pages/SkillGlow/CandidateMain";
import SkillCandidate from "./pages/SkillGlow/SkillCandidate";
import CreateSkillCandidate from "./pages/SkillGlow/CreateSkillCandidate";
import EmployeeSchedule from "./pages/SkillGlow/EmployeeSchedule";
import SkillInsights from "./pages/SkillGlow/Insights";
import Editoverheadtype from "./pages/FinanceModule/Editoverheadtype";
import NewCreateCategoryMain from "./pages/SkillGlow/NewCreateCategory";
import CreateAppraisalSkill from "./pages/SkillGlow/AppraisalSkill";
import SkillCreate from "./pages/SkillGlow/SkillCreate";
import CreateSurvey from "./pages/SkillGlow/CreateSurvey";
import CreateCompliance from "./pages/SkillGlow/CreateCompliance";
import CreateFeedBack from "./pages/SkillGlow/CreateFeedBack";
import NewSchedule from "./pages/SkillGlow/NewSchedule";
import NewScheduleLatest from "./pages/SkillGlow/NewScheduleLatest";
import EditLeader from "./pages/HR/Editleader";
import LeaderCardView from "./pages/HR/Leadercardview";
import AppraisalSchedule from "./pages/SkillGlow/AppraisalSchedule";
import AppraisalScheduleList from "./pages/SkillGlow/AppraisalScheduleList";
import EditOrder from "./pages/HR/Editorder";
import EditOrderitem from "./pages/HR/Editorderitem";
import EditPaymentStatus from "./pages/HR/EditPaymentStatus";
import EditAdvancePayment from "./pages/HR/EditPaymentStatus";
import EditItemGroup from "./pages/Item/EditItemGroup";
import EditHSNCategory from "./pages/Item/EditHSNCategory";
import EditHSNMaster from "./pages/Item/EditHSNMaster";
import EditItemCategory from "./pages/Item/EditItemCategory";
import EditItem from "./pages/Item/EditItem";
import EditRoute from "./pages/Route/EditRoute";
import EditArea from "./pages/Route/EditArea";
//import ChangeyourPassword from "./Security/Passwordflow";
import ChangeyourPassword_1 from "./Security/Passwordflow";
import Logochange from "./Security/Changelogo";
import LoginChangepass from "./Security/Loginchangepassword";

import ViewLeadEnquiry from "./pages/HR/ViewLeadEnquiry";
import Companychange from "./Security/Changecompany";
import Changehdrftr from "./Security/ChangeHdrftr";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import EditLeaveEnquiry from "./pages/HR/EditLeaveEnquiry";
import EditOHPayment from "./pages/HR/EditOHPayment";
import PartyByDate from "./pages/HR/PartyByDate";
import LeaveEntryRegister from "./pages/Empolyee/LeaveEntryRegsiter";
import EditAudit from "./pages/HR/EditAudit";
import Editparentcontact from "./pages/HR/Editparentcontact";
import GSPdf from "./pages/Empolyee/GSPdf";
import BRRForm from "./pages/SOP/BRRForm";
import EditListOfSOPs from "./pages/SOP/EditListOfSOPs";
import EditSOPDocument from "./pages/SOP/EditSOPDocument";
import EditBooklet from "./pages/SOP/EditBooklet";
import EditSopCheckList from "./pages/SOP/EditCheckList";
import AnnexureForm1 from "./pages/SOP/AnnexureForm1";
import AnnexureForm2 from "./pages/SOP/AnnexureForm2";
import ScoreBoard from "./pages/SkillGlow/ScoreBoard";
import BatchTimeLine from "./pages/SOP/BatchTimeline";
import Editdoccategory from "./pages/HR/Editdoccategory";
import Editdocument from "./pages/HR/Editdocument";
import StaffTimetable from "./pages/Empolyee/StaffTimetable";
import EditPayment from "./pages/Empolyee/Editpayment";
import InvoiceAnalytics from "./pages/Empolyee/InvoiceAnalytics";
import TeacherOccupancy from "./pages/HR/EditTeachOccupancy";
import EditAcademicyear from "./pages/HR/EditAcademicyear";
import Editdebitcash from "./pages/FinanceModule/EditDebit";
import Editdepositcash from "./pages/FinanceModule/EditDeposit";
import EditTerms from "./pages/HR/EditTerms";
import EditSlotgroup from "./pages/HR/EditSlotgroup";
import EditSlots from "./pages/HR/EditSlots";
import CRMPartyAnalytics from "./pages/DashBoards/CRMPartyAnalytics";
// import Editpayrollattendance from "./pages/Empolyee/Editpayrollattendance";
import EditTimetablev1 from "./pages/Empolyee/EditTimetablev1";
import ProjectTimeTable from "./pages/Empolyee/ProjectTimeTable";
import EditSettlements from "./pages/HR/EditSettlements";
import EventsType from "./pages/HR/EventsType";
import EditEmergency from "./pages/HR/EditEmergency";
import EditAcademicsForm from "./pages/HR/EditAcademicsForm";
import EditSports from "./pages/HR/EditSports";
import EditCulturals from "./pages/HR/EditCulturals";
import Circular from "./pages/HR/Cirucular";
import EditPTA from "./pages/HR/EditPTAmeeting";
import EditWorkshop from "./pages/HR/EditWorkshop";
import EditTermfeesstructure from "./pages/Empolyee/EditTermfeestruct";
import EditAnnualfeestructure from "./pages/Empolyee/EditAnnualFeeStruct";
import RaiseComplaints from "./pages/Empolyee/RaiseComplaints";

function App() {
  //   useEffect(() => {
  //   const grace = sessionStorage.getItem("CompanyGraceTime");
  //   const timeout = sessionStorage.getItem("CompanySessionTimeOut");

  //   console.log("Grace:", grace);
  //   console.log("Timeout:", timeout);
  // }, []);

  //   const [theme, colorMode] = useMode();

  //   const IDLE_TIME = 5 * 120 * 1000;

  //   const navigate = useNavigate();
  //   const timerRef = useRef(null);

  //   const handleSessionExpire = () => {
  //     toast.error("Session expired due to inactivity. Please login again.", {
  //       style: {
  //         fontSize: "20px",
  //         padding: "20px 28px",
  //         minWidth: "380px",
  //         textAlign: "center",
  //         lineHeight: "1.4",
  //       },
  //       autoClose: 10000,
  //     });

  //     sessionStorage.clear();
  //     navigate("/");
  //   };

  //   const resetTimer = () => {
  //     clearTimeout(timerRef.current);
  //     // timerRef.current = setTimeout(handleSessionExpire, IDLE_TIME);
  //     timerRef.current = setTimeout(handleSessionExpire, sessionTime*1000);
  //   };
  //   const [sessionTime, setSessionTime] = useState(null);

  const [sessionTime, setSessionTime] = useState(null);

  //  Load Session Timeout (seconds → milliseconds)
  const [theme, colorMode] = useMode();
  const navigate = useNavigate();
  const timerRef = useRef(null);
  useEffect(() => {
    const timeout = sessionStorage.getItem("CompanySessionTimeOut");

    if (timeout) {
      const timeoutInMs = Number(timeout) * 1000;
      setSessionTime(timeoutInMs);
      console.log("Session timeout (ms):", timeoutInMs);
    } else {
      console.log("No CompanySessionTimeOut found in sessionStorage");
    }
  }, []);

  //  Logout function
  const handleSessionExpire = () => {
    toast.error("Session expired due to inactivity. Please login again.", {
      style: {
        fontSize: "20px",
        padding: "20px 28px",
        minWidth: "380px",
        textAlign: "center",
        lineHeight: "1.4",
      },
      autoClose: 10000,
    });

    sessionStorage.clear();
    navigate("/");
  };

  // Reset Timer
  const resetTimer = () => {
    if (!sessionTime) return;

    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(handleSessionExpire, sessionTime);
  };

  // Attach Activity Listeners
  useEffect(() => {
    if (!sessionTime) return;

    const events = ["mousemove", "keydown", "scroll", "click"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer initially

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, [sessionTime]);

  useEffect(() => {
    const storedSessionTime = sessionStorage.getItem("sessiontime");

    if (storedSessionTime) {
      setSessionTime(storedSessionTime);
      console.log(storedSessionTime, "Session Time from storage");
    } else {
      console.log("No sessiontime found");
    }
  }, []);

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {/* <Sidebars/> */}
          <MyProSidebarProvider>
            <div style={{ height: "100%", width: "100%" }}>
              <main className="content">
                {/* <Topbar Tittle={screenName} /> */}

                <Routes>
                  <Route
                    path="/:accessID/:screenName/EditEmployee Payroll/:id/:Mode"
                    element={<EditemployeePayroll />}
                  />
                  <Route
                    path="/CRMPartyAnalytics"
                    element={<CRMPartyAnalytics />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditPayroll configuration/:id/:Mode"
                    element={<EditemployeePayroll />}
                  />

                  <Route
                    path="/:accessID/:screenName/EditPayroll/:id/:Mode"
                    element={<EditemployeePayroll />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditEmployee Request/:id/:Mode"
                    element={<Editrequests />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditApproval/:id/:Mode"
                    element={<Editapprovals />}
                  />
                  <Route
                    path="/:accessID/:screenName/Editrunpayroll"
                    element={<Editrunpayroll />}
                  />
                  <Route
                    path="/:accessID/Regularization/:id/"
                    element={<Regularization />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/:filtertype/EditPayment/:id/:Mode"
                    element={<EditPayment />}
                  />
                  <Route
                    path="/:accessID/:screenName/Invoice/Analytics"
                    element={<InvoiceAnalytics />}
                  />
                  {/* SKILL GLOW */}

                  {/* SCHEDULE */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:secondaryAccessID/:parentID1"
                    element={<ListviewSecondary />}
                  />

                  {/* SCHEDULE */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID3/:parentID2/:secondaryAccessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID1/:screenName1/:parentID2/:screenName/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* /Apps/Secondarylistview/TR371/BFWEnquiry/2/Detail/TR372/691 */}
                  {/* /Apps/Secondarylistview/TR371/DMEnquiry/2/TR372/693 */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/:Type"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/:Type/:OrderType"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID"
                    element={<ListviewSecondary />}
                  />
                  {/* /Apps/Secondarylistview/TR304/Marketing%20Activity/31/84 */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID3/:parentID2/:accessID/:parentID1/EditList Of Assessment Category/:id/:Mode"
                    element={<CreateCandidates />}
                  />

                  {/* Session */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:parentID1"
                    element={<ListviewSecondary />}
                  />

                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:parentID1/EditList Of Session/:id/:Mode"
                    element={<CreateSession />}
                  />

                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID3/:accessID1/:parentID2/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* NEW SESSION */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID3/:accessID1/:parentID2/:accessID/:parentID1/EditListOfSession/:id/:Mode"
                    element={<CreateSession />}
                  />
                  {/* NEW SCHEDULE */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID4/:accessID1/:parentID3/:accessID/:parentID2/:parentID1"
                    element={<NewSchedule />}
                  />

                  {/* QUESTION GROUP */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:parentID1"
                    element={<ListviewSecondary />}
                  />

                  {/* NEW QUESTION GROUP */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID3/:accessID1/:parentID2/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID2/:parentID1/EditList Of Question Groups/:id/:Mode"
                    element={<CreateCategory />}
                  />
                  {/* NEW QUESTION GROUP CREATE */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID3/:accessID1/:parentID2/:accessID/:parentID1/EditListOfQuestionGroups/:id/:Mode"
                    element={<CreateCategory />}
                  />

                  {/* QUESTION */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID3/:parentID2/:secondaryAccessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID3/:parentID2/:accessID/:parentID1/EditList Of Question Groups/:id/:Mode"
                    element={<CreateQuestion />}
                  />
                  {/* NEW QUESTION */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID3/:screenName/:parentID4/:accessID2/:parentID3/:accessID1/:parentID2/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* NEW QUESTION CREATE */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID3/:screenName/:parentID4/:accessID2/:parentID3/:accessID1/:parentID2/:accessID/:parentID1/EditListOfQuestion/:id/:Mode"
                    element={<CreateQuestion />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID3/:parentID2/:accessID/:parentID1/EditList Of Question Groups/:id/:Mode"
                    element={<CreateQuestion />}
                  />

                  {/* PARTY BY DATE FILTER */}
                  <Route path="/Party/AgingReport" element={<PartyByDate />} />
                  <Route
                    path="/SkillGlow/CategoryMain"
                    element={<CategoryMain />}
                  />
                  <Route
                    path="/SkillGlow/Assessment/Schedule/EmployeeSchedule"
                    element={<EmployeeSchedule />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditList Of Categories/:id/:Mode"
                    element={<CreateCategoryMain />}
                  />

                  {/*NEW CREATE CATEGORY  */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID1/EditList Of Assessment Category/:id/:Mode"
                    element={<NewCreateCategoryMain />}
                  />
                  {/* NEW SKILL ASSESSMENT */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1/EditList Of Assessment Category/:id/:Mode"
                    element={<SkillCreate />}
                  />

                  {/* APPRAISAL LIST */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* NEW APPRAISAL CREATE */}
                  {/* <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1/EditList Of Appraisal/:id/:Mode"
                    element={<CreateAppraisalSkill />}
                  /> */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1/EditListOfAppraisal/:id/:Mode"
                    element={<CreateAppraisalSkill />}
                  />
                  {/* NEW SURVEY CREATE */}

                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1/EditListOfSurvey/:id/:Mode"
                    element={<CreateSurvey />}
                  />

                  {/* NEW COMPLIANCE CREATE */}

                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1/EditListOfCompliance/:id/:Mode"
                    element={<CreateCompliance />}
                  />

                  {/* NEW FEEDBACK CREATE */}

                  <Route
                    path="/Secondarylistview/skillglow/:accessID1/:screenName/:parentID2/:accessID/:parentID1/EditListOfFeedBack/:id/:Mode"
                    element={<CreateFeedBack />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID4/:accessID1/:parentID3/ScheduleListAssessment/:parentID2"
                    element={<NewScheduleLatest />}
                  />
                  {/* APPRAISAL DESIGNATION LIST*/}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID3/:accessID1/:parentID2/:accessID/AppraisalSchedule/"
                    element={<ListviewSecondary />}
                  />

                  {/* APPRAISAL SCHEDULE */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID3/:screenName/:parentID3/:accessID2/:parentID2/:accessID1/AppraisalSchedule/AppraisalScheduleEMP/:parentID1"
                    element={<AppraisalSchedule />}
                  />
                  {/* APPRAISAL SCHEDULE LIST*/}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID3/:screenName/:parentID3/:accessID2/:parentID2/:accessID1/AppraisalSchedule/AppraisalScheduleListEMP/:parentID1"
                    element={<AppraisalScheduleList />}
                  />
                  {/* ASSESSMENT SCORE BOARD*/}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID2/:screenName/:parentID4/:accessID1/:parentID3/ScheduleListAssessment/:parentID2/AssessmentScoreBoard/:parentID1"
                    element={<ScoreBoard />}
                  />

                  {/* ITEM GROUP EDIT */}
                  <Route
                    path="/:accessID/:screenName/EditItem Group/:id/:Mode"
                    element={<EditItemGroup />}
                  />
                  {/* ITEM CATEGORY LIST VIEW*/}
                  <Route
                    path="/Secondarylistview/Item Group/:accessID/:screenName/:parentID2/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* ITEM CATEGORY EDIT */}
                  <Route
                    path="/Secondarylistview/Item Group/:accessID/:screenName/:parentID2/:parentID1/EditItemCategory/:id/:Mode"
                    element={<EditItemCategory />}
                  />
                  <Route
                    path="/Secondarylistview/Classification/:accessID/:screenName/:filtertype/EditPersonnel/:id/:Mode"
                    element={<Editemployee />}
                  />
                  <Route
                    path="/SecondarylistView/Classification/:accessID/:screenName/:filtertype"
                    element={<ListviewSecondary />}
                  />
                  {/* ITEM LIST VIEW*/}
                  <Route
                    path="/Secondarylistview/Item Group/:accessID1/:screenName/:parentID3/:parentID2/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* ITEM EDIT */}
                  <Route
                    path="/Secondarylistview/Item Group/:accessID1/:screenName/:parentID3/:parentID2/:accessID/:parentID1/EditItemCategory/:id/:Mode"
                    element={<EditItem />}
                  />
                  {/* HSN CATEGORY EDIT */}
                  <Route
                    path="/:accessID/:screenName/EditHSN Category/:id/:Mode"
                    element={<EditHSNCategory />}
                  />

                  {/* For SOPs Edit */}
                  <Route
                    path="/:accessID/:screenName/EditList Of SOPs/:id/:Mode"
                    element={<EditListOfSOPs />}
                  />

                  {/* HSN MASTER LIST VIEW*/}
                  <Route
                    path="/Secondarylistview/HSN/:accessID/:screenName/:parentID2/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* HSN MASTER EDIT */}
                  <Route
                    path="/Secondarylistview/HSN/:accessID/:screenName/:parentID2/:parentID1/EditHSNMaster/:id/:Mode"
                    element={<EditHSNMaster />}
                  />
                  {/* ROUTE EDIT */}
                  <Route
                    path="/:accessID/:screenName/EditRoute/:id/:Mode"
                    element={<EditRoute />}
                  />
                  {/* AREA EDIT */}
                  <Route
                    // path="/:accessID/:screenName/EditHSN Category/:id/:Mode"
                    path="/Secondarylistview/Route/:accessID/:screenName/:parentID1/EditRouteArea/:id/:Mode"
                    element={<EditArea />}
                  />
                  {/* AREA EDIT */}
                  <Route
                    // path="/:accessID/:screenName/EditHSN Category/:id/:Mode"
                    path="/Secondarylistview/Route/:accessID/:screenName/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* STAFF TIMETABLE */}
                  <Route
                    // path="/Staff/StaffTimetable/:CompanyID/:EmployeeID/:TermsID"
                    path="/StaffTimetable/:id"
                    element={<StaffTimetable />}
                  />

                  <Route
                    path="SkillGlow/CandidateMain"
                    element={<CandidateMain />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList"
                    element={<SkillGlowList />}
                  />
                  <Route
                    path="/SkillGlow/SkillInsights"
                    element={<SkillInsights />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList/SkillGlowSession"
                    element={<SkillSession />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList/SkillCategory"
                    element={<SkillCategory />}
                  />
                  {/* <Route
                    path="/SkillGlow/SkillGlowList/CreateSkill"
                    element={<CreateSkill />}
                  /> */}

                  {/* OLD SKILL */}
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID1/EditList Of Assessment/:id/:Mode"
                    element={<CreateSkill />}
                  />

                  <Route
                    path="/SkillGlow/Assessment/Candidates/SkillCandidate/CreateSkillCandidate"
                    element={<CreateSkillCandidate />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList/SkillCategory/CreateCategory"
                    element={<CreateCategory />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList/SkillCategory/QuestionList"
                    element={<QuestionList />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList/SkillCategory/QuestionList/CreateQuestion"
                    element={<CreateQuestion />}
                  />
                  <Route
                    path="/SkillGlow/SkillGlowList/CandidateList"
                    element={<CandidateList />}
                  />

                  {/* <Route
                    path="SkillGlow/SkillGlowList/SkillGlowSession/CreateSession"
                    element={<CreateSession />}
                  /> */}

                  <Route
                    path="SkillGlow/SkillGlowList/SkillCategory/QuestionList/Details"
                    element={<QuestionDetails />}
                  />
                  <Route
                    path="SkillGlow/Assessment/Candidates/SkillCandidate"
                    element={<SkillCandidate />}
                  />
                  {/* SKILL GLOW */}
                  <Route
                    path="/:accessID/:screenName/EditSalary Component/:id/:Mode"
                    element={<EditSalaryComponent />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditPayroll Policy/:id/:Mode"
                    element={<EditSatuaryComponent />}
                  />
                  <Route path="/:accessID/:screenName" element={<Listview />} />
                  <Route path="/pdf" element={<MyDocument />} />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc/all-bom/:bomproductid/EditList of BOM/:id/:mode"
                    element={<Editbom />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:headerid/:Type/EditProduct Master/:id/:Mode"
                    element={<Editproduct />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCategories/:id/:Mode"
                    element={<Editproductcategory />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditLeave Type/:id/:Mode"
                    element={<LeaveType />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditHoliday List/:id/:Mode"
                    element={<Holidaylist />}
                  />

                  <Route
                    path="/:accessID/:screenName/EditJobwork Category/:id/:Mode"
                    element={<Editjobworkcategory />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditJob-Work/:id/:Mode"
                    element={<EditJobwork />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/EditMaterial Category/:id/:Mode"
                    element={<Editmaterialcategory />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:invoiceType/EditLocal Invoice/:id/:Mode"
                    element={<Editlocalinvoce />}
                  />
                  <Route path="/change Password" element={<Changepass />} />
                  {/* Settings */}
                  <Route path="/settings" element={<Settings />} />
                  <Route
                    path="/configuration/:Mode"
                    element={<Configuration />}
                  />

                  <Route
                    path="/:screenName/imageupload/:accessID/:id"
                    element={<Imageupload />}
                  />

                  <Route
                    path="/leaveenquiry/:id"
                    element={<EditLeaveEnquiry />}
                  />
                  <Route
                    path="/LeaveTypeRegister/:id"
                    element={<LeaveEntryRegister />}
                  />

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/EditMaterial Category/imageupload/:id"
                    element={<Imageupload />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/:Type/:parentName/:SearchPhrase/imageupload/:id"
                    element={<Imageupload />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/:parentName/imageupload/:id"
                    element={<Imageupload />}
                  />
                  {/* <Route path="/Chart" element={<Chartboard />} /> */}
                  <Route path="/HR" element={<Logopage />} />
                  <Route
                    path="/ChangeyourPassword_1"
                    element={<ChangeyourPassword_1 />}
                  />
                  <Route
                    path="/ChangeyourPassword_2"
                    element={<Logochange />}
                  />
                  <Route
                    path="/ChangeyourPassword_3"
                    element={<LoginChangepass />}
                  />
                  <Route
                    path="/ChangeyourPassword_4"
                    element={<Companychange />}
                  />
                  <Route
                    path="/ChangeyourPassword_5"
                    element={<Changehdrftr />}
                  />

                  <Route
                    path="/:accessID/Editproductstock/:id/:Code/:Desc/:Mode"
                    element={<Editproductstock />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:stckid/:filtertype/:Desc/:searchPharse/pm/Editstock/:id/:Mode"
                    element={<Editstock />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditBOMS/:id/:Mode"
                    element={<Editbom />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCustomers/:id/:Mode/:show"
                    element={<Editcustomermaster />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/:Desc/Editprocess/:id/:Mode"
                    element={<Editprocess />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditSuppliers/:id/:Mode"
                    element={<Editsupplymaster />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditBank/:id/:Mode"
                    element={<Editbankmasters />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCompany/:id/:Mode"
                    element={<Editcompany />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditPersonnel/:id/:Mode"
                    element={<Editemployee />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditEmpfinance entry/E/:RecordID/:Name"
                    element={<EditEmpfinance />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditUOM/:id/:Mode"
                    element={<Edituom />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditUOM Conversion/:id/:Mode"
                    element={<Edituomconversion />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditDepartment/:id/:Mode"
                    element={<Editdept />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditTax Master/:id/:Mode"
                    element={<Edittaxmaster />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCurrency/:id/:Mode"
                    element={<Editcurrency />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentrecID/:materialType/EditColors/:id/:Mode"
                    element={<Editcolorshades />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentrecID/:materialType/:colorShade/EditColors-customer/:id/:Mode"
                    element={<Editcolorcustomer />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:materialType/EditColors/:id/:Mode"
                    element={<Editcolor />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCountry/:id/:Mode"
                    element={<Editcountry />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditLeather Master/:id/:Mode"
                    element={<Editleathermaster />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditAirlines/:id/:Mode"
                    element={<Editairlines />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditDesign Pattern/:id/:Mode"
                    element={<Editdesignpattern />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditGrade/:id/:Mode"
                    element={<Editgrade />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditPaurchase Order Parameter/:id/:Mode"
                    element={<EditPurchaseOrderParameter />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditSubstance/:id/:Mode"
                    element={<Editsubstance />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditUOM/:id/:Mode"
                    element={<Edituom />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:invFilter/EditProforma Invoice/:id/:Mode"
                    element={<Editproformainvoice />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:invFilter/Editpostshipment/:id/:Mode"
                    element={<Editpostshipment />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:headerid/:filtertype/:Desc/:searchPharse/pm/EditList of Materials/:id/:Mode"
                    element={<Editmatrial />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:secondaryAccessID/:parentRecID/DC/:remarkType/:remarkDec/EditDelivery Chalan/:id/:Mode"
                    element={<Editdeliverychalan />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCustomer Order/:id/:Mode"
                    element={<Editcustomerorder />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype"
                    element={<ListviewSecondary />}
                  />

                  {/* NEW ORDER ITEM LIST VIEW */}
                  {/* <Route
                    path="/Secondarylistview/:accessID1/:screenName/:filtertype/:Type/:accessID/:filtertype1"
                    element={<ListviewSecondary />}
                  /> */}
                  <Route
                    // path="/Secondarylistview/:accessID1/:OrderType/:filtertype/:Type/:screenName/:accessID/:filtertype1"
                    path="/Secondarylistview/:accessID1/:screenName/:filtertype/:Type/:OrderType/:accessID/:filtertype1"
                    element={<ListviewSecondary />}
                  />
                  {/* FEES STRUCTURE */}
                  <Route
                    // path="/SecondarylistView/:accessID1/:screenName1/:parentID2/:screenName/:accessID/:parentID1"
                    path="/SecondarylistView/:accessID1/Project/:parentID3/Academic Type/:accessID1/:parentID2/:screenName/:accessID/:parentID1"
                    element={<ListviewSecondary />}
                  />
                   <Route
                  path="/SecondarylistView/:accessID1/Project/:parentID3/Academic Type/:accessID1/:parentID2/:screenName/:accessID/:parentID1/EditTerm Fees Structure/:id/:Mode"
                  element={<EditTermfeesstructure />}
                  />
                   <Route
                  path="/SecondarylistView/:accessID1/Project/:parentID3/Academic Type/:accessID1/:parentID2/:screenName/:accessID/:parentID1/EditAnnual Fees Structure/:id/:Mode"
                  element={<EditAnnualfeestructure />}
                  />
                   {/* EVENTS */}
                  <Route
                    // path="/Secondarylistview/:accessID1/:screenName1/:leaderID/:screenName/:accessID/:parentID2/:parentID1"
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/:Type"
                    element={<ListviewSecondary />}
                  />
                  {/* EMERGENCY */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/E/EditEvent Category/:id/:Mode"
                    element={<EditEmergency />}
                  />
                  {/* ACADEMMICS */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/A/EditEvent Category/:id/:Mode"
                    element={<EditAcademicsForm />}
                  />
                  {/* SPORTS */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/S/EditEvent Category/:id/:Mode"
                    element={<EditSports />}
                  />
                  {/* CULTURALS */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/C/EditEvent Category/:id/:Mode"
                    element={<EditCulturals />}
                  />
                  {/* HOLIDAY */}
                  {/* <Route
                    path="/Secondarylistview/:accessID1/:screenName1/:parentID3/:screenName/:accessID/:parentID2/HO/Event Category/:id/:Mode"
                    element={<EditHolidayevent />}
                  /> */}
                  {/* CIRCULAR */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/CI/EditEvent Category/:id/:Mode"
                    element={<Circular />}
                  />
                  {/* PTA */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/PTA/EditEvent Category/:id/:Mode"
                    element={<EditPTA />}
                  />
                  {/* WORKSHOP */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:leaderID/Events/:secondaryAccessID/:parentID2/W/EditEvent Category/:id/:Mode"
                    element={<EditWorkshop />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditRemarks/:id/:Mode"
                    element={<Editremarks />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditFinancial Year/:id/:yearid/:Mode"
                    element={<Editopeningstock />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:PcdhRecordID/:Number/:Decs/EditIssue/:id/:MaterialDescription/:ItemType/:HeaderQty/:Mode"
                    element={<Editissue />}
                  />
                  <Route
                    path="/Secondarylistview/skillglow/:accessID/:screenName/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID1/:Type"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:DocumentID"
                    element={<ListviewSecondary />}
                  />

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc/all-bom/:bomproductid"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:Desc/:searchPharse/pm"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:CusID/:secondaryAccessID/:InvoiceName/:InvType"
                    element={<ListviewSecondary />}
                  />

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Desc/EditProforma%20Invoice/:id/:Mode/Editworkinprocess/:productID/:proformaID/:bomID/:proformaRecid"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:invFilter/EditProforma Invoice/:id/:Mode/Timeline/:RecordID"
                    element={<TimeLine />}
                  />
                  <Route path="*" element={<NotFound />} />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/EditBATCHS/:id/:Mode"
                    element={<Editbatch />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/Editbatchcompletion/:id/:Mode"
                    element={<Editbatchcompletion />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/Editbatchissue/:id/:Mode"
                    element={<Editbatchissue />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/Editbatchissue/:id/:Mode/:Edit"
                    element={<Editbatchissue />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:invFilter/EditProforma Invoice/:id/:Mode/Editworkinprocess/:productID/:proformaID/:bomID/:proformaRecid/E"
                    element={<Editworkingprocess />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditStock Enquiry/:id/:Mode"
                    element={<Editindcoutdc />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/EditPacking List/:id/:Mode"
                    element={<Editpackinglist />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/EditAssorted/:id/:Mode"
                    element={<Editassorted />}
                  />
                  {/* <Route path="/:accessID/:screenName/EditPacking List/:id/:Mode" element={ <Editpackinglist/>}/> */}
                  <Route
                    path="/:accessID/:screenName/EditLeather Packing List/:id/:Mode"
                    element={<Editpacking />}
                  />
                  <Route
                    path="/:accessID/Production Card/EditInspection Form/:id"
                    element={<Editinspection />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditOverhead/:id/:Mode"
                    element={<Editoverhead />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditOver Head/:id/:Mode"
                    element={<Editoverhead />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditOverhead Type/:id/:Mode"
                    element={<Editoverheadtype />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditIndent Purchase Order/:id/:Mode"
                    element={<Editpurchaseorder />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditOpen Purchase Order/:id/:Mode"
                    element={<Editpurchaseorderopen />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/:filtertype/EditFinance Entry/:id/:Mode"
                    element={<Editfinance />}
                  />
                  {/* <Route
                    path="/:accessID/:screenName/EditCosting/:id/:Mode"
                    element={<Editcosting />}
                  /> */}
                  <Route
                    path="/:accessID/:screenName/price-of-other-customer/:id"
                    element={<Editpriceofothercustomer />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditUser/:id/:Mode"
                    element={<Edituser />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditUser Group/:id/:Mode"
                    element={<Editusergroup />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditHSN/:id/:Mode"
                    element={<EditHsn />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:secondaryAccessID/:parentRecID/DC/:remarkType/:remarkDec"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenNamePre/:filtertype/:prdNumber/:secondaryAccessID/:screenName/PC/:remarkType/:remarkDec"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:productID/:productDescription/:customerID/costing-product/:bomVersion/:bomID/:secondaryAccessID"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:productID/:productDescription/:customerID/costing-product/:bomVersion/:bomID/:secondaryAccessID/:FirstLeatherID/EditCosting/:id/:Mode"
                    element={<Editcosting />}
                  />
                  <Route
                    path="/TR140/Customer-Product/EditCustomer-Product/:id/:Mode"
                    element={<Editcosting />}
                  />
                  {/* <Route
                    path="/TR140/Customer-Product/EditCustomer-Product-new/:id/:Mode"
                    element={<Editcostingnew />}
                  /> */}
                  <Route
                    path="/:accessID/:screenName/EditReport/:id/:Mode"
                    element={<Editreport />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:supplierID/:parenid/:prdCardNo/:Type/EditIndent Order/:id/:Mode"
                    element={<Editindentorder />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:supplierID/:parentid/:prdCardNo/:Type/EditMaterial IndentOrder/:id/:Mode"
                    element={<Editpurchaseindent />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditProduct Tracking/:id/:Mode"
                    element={<Editproducttracking />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Number/:orderQuantity/:prdaccessID/EditProduction"
                    element={<Editproduction />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditProduction/:id/:Mode"
                    element={<Editproduction />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCustomer Line Chart/:id/:Mode"
                    element={<Editcustomerlinechart />}
                  />
                  {/* <Route path="/:accessID/:screenName/EditProduct Line Chart/:id/:Mode" element={ <Editproductlinechart/>}/> */}
                  <Route
                    path="product-analysis/:id/:Mode"
                    element={<ProductAnalysis />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditFunctions/:id/:Mode"
                    element={<Editfunction />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditDesignation/:id/:Mode"
                    element={<Editdesignation />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCheck In/:id/:Mode"
                    element={<Editcheckin />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditCheck In/:id/:Mode"
                    element={<Editcheckin />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditCheck Out/:id/:Mode"
                    element={<Editcheckout />}
                  />
                  {/* <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditCheck Out/:id/:Mode"
                    element={<EditEmpCheckout />}
                  /> */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditCheck Out/:id/:Mode"
                    element={<Editcheckout />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID/EditCheck In/:id/:Mode"
                    element={<EditEmpCheckin />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditLocation/:id/:Mode"
                    element={<Editlocation />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:Type/stock-care-by"
                    element={<Editstockcare />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/EditGate Entry/:id/:Mode"
                    element={<Editgate />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/EditBins/:id/:Mode"
                    element={<Editbin />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:conscreenName/:filtertype/EditDailyTask/:id/:Mode"
                    element={<EditDailytask />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/EditDaily Hour Task/:id/:Mode"
                    element={<EditDailyHourstask />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditFixed Asset Type/:id/:Mode"
                    element={<Editfixedassettype />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditFixed Assets Category/:id/:Mode"
                    element={<Editfixedassetcategory />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:parentID/EditFixed Assets/:id/:Mode"
                    element={<Editfixedasset />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditProject/:id/:Mode"
                    element={<Editproject />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditProject/:id/:Mode"
                    element={<Editproject />}
                  />

                  <Route
                    path="/:accessID/:screenName/EditRole/:id/:Mode"
                    element={<EditRole />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditMilestones/:id/:Mode"
                    element={<EditMilestones />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditStages/:id/:Mode"
                    element={<Editoperation />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditActivities/:id/:Mode"
                    element={<EditActivities />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditTask/:id/:Mode"
                    element={<Edittask />}
                  />
                  <Route
                    path="/:accessID/:screenName/Editweightage/:Type/:id/:Mode"
                    element={<EditmileWeightage />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditParty/:id/:Mode"
                    element={<Editvendor />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditSettlements/:id/:Mode"
                    element={<EditSettlements />}
                  />

                  <Route
                    path="/:accessID/Editattendance"
                    element={<EditAttendance />}
                  />
                  <Route path="/:accessID/EditAudit" element={<EditAudit />} />
                  <Route
                    path="/:accessID/Editdailyattendance"
                    element={<EditdailyAttendance />}
                  />
                  <Route
                    path="/:accessID/EditAttendanceHistory"
                    element={<EditAttendanceHistory />}
                  />
                  <Route
                    path="/:accessID/EditTimeSheet"
                    element={<EditTimeSheet />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditTimeDailytask/:id"
                    element={<EditTimeDailytask />}
                  />

                  {/* Sprint */}

                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditSprint/:id/:Mode"
                    element={<EditSprint />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditShift/:id/:Mode"
                    element={<Editshift />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditAcademicyear/:id/:Mode"
                    element={<EditAcademicyear />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditSlot Group/:id/:Mode"
                    element={<EditSlotgroup />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditSlot/:id/:Mode"
                    element={<EditSlots />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditTerms/:id/:Mode"
                    element={<EditTerms />}
                  />
                  {/* <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/EditSlots/:id/:Mode"
                    element={<EditSlots />}
                  /> */}
                  <Route
                    path="/Edittimesheetreport"
                    element={<Edittimesheetreport />}
                  />
                  <Route
                    path="/Biometric"
                    element={<Biometricconfiguration />}
                  />
                  <Route path="/Approval" element={<Approval />} />

                  <Route
                    path="/:accessID/:screenName/EditContracts In/:id/:Mode"
                    element={<EditContractsin />}
                  />

                  <Route
                    path="/:accessID/:screenName/EditDocument Category/:id/:Mode"
                    element={<Editdoccategory />}
                  />
                  <Route
                    // path="/Secondarylistview/:accessID/:screenName/:id1/:filtertype/EditDocument/:id/:Mode"
                    // path="/Secondarylistview/:accessID/:screenName/:filtertype/EditDocument/:id/:Mode"
                    path="/Secondarylistview/Document Category/:accessID/:screenname/:parentID1/EditDocument/:id/:Mode"
                    element={<Editdocument />}
                    // /Apps/Secondarylistview/Document%20Category/TR362/Document/1/EditDocument/-1/A
                  />
                  {/* /Apps/Secondarylistview/Document Category/TR362/Document/${params.row.RecordID} */}

                  {/* DOCUMENT LIST */}
                  <Route
                    path="/Secondarylistview/Document Category/:accessID/:screenName/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditContracts Out/:id/:Mode"
                    element={<EditContractsout />}
                  />
                  <Route
                    path="/:accessID/:screenName/EditContracts Out/:id/:Mode"
                    element={<EditContractsout />}
                  />
                  {/* Type S */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Name/EditLeader/:id/:Mode/:Type"
                    // /Apps/Secondarylistview/TR304/Leader/168/Nk/EditLeader/-1/A/F
                    // path="Secondarylistview/:accessID/:screenName/EditLeader/:id/:Mode"
                    element={<EditLeader />}
                  />
                  {/* Type T */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Type/EditMarketing Activity/:id/:Mode"
                    // /Apps/Secondarylistview/TR304/Marketing%20Activity/45/T/EditMarketing%20Activity/-1/A
                    element={<EditLeader />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/LeaderCardView/:partyID"
                    element={<LeaderCardView />}
                  />
                  {/* <Route
                    path="/Secondarylistview/LeadEnquiry/ViewLeadEnquiry/:LeadId"
                    element={<ViewLeadEnquiry />}
                  /> */}
                  <Route
                    path="/Secondarylistview/LeadEnquiry/ViewLeadEnquiry/:partyID/:LeadId"
                    element={<ViewLeadEnquiry />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Type/:OrderType/EditOrder/:id/:Mode"
                    // /Apps/Secondarylistview/TR304/Order/30/EditOrder/A
                    element={<EditOrder />}
                  />

                  {/* PAYMENT - ORDER HEADER */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:filtertype/:Type/:OrderType/EditPayment/:id/:Mode"
                    // /Apps/Secondarylistview/TR304/Order/30/EditOrder/A
                    element={<EditOHPayment />}
                  />

                  {/* ADVANCE PAYMENT */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:partyID"
                    element={<ListviewSecondary />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:partyID/EditAdvancePayment/:id/:Mode"
                    element={<EditAdvancePayment />}
                  />
                  {/* <Route
                      path="/Secondarylistview/:accessID/:screenName/:filtertype/EditOrderitem/:id/:Mode"
                    // /Apps/Secondarylistview/TR304/Order/30/EditOrder/A
                    element={<EditOrderitem />}
                  /> */}

                  {/* WORKING BEFORE ORDERTYPE IMPLEMENTATION */}
                  {/* <Route
                    path="/Secondarylistview/:accessID1/:screenName/:filtertype/:Type/:accessID/:filtertype1/EditOrderitem/:id/:Mode"
                    element={<EditOrderitem />}
                  /> */}
                  {/* <Route
                    path="/Secondarylistview/:accessID1/:screenName/:filtertype/:Type/:OrderType/:accessID/:filtertype1"
                    element={<ListviewSecondary />}
                  /> */}
                  <Route
                    path="/Secondarylistview/:accessID1/:screenName/:filtertype/:Type/:OrderType/:accessID/:filtertype1/EditOrderitem/:id/:Mode"
                    element={<EditOrderitem />}
                  />
                  <Route
                    path="/Parentcontact"
                    element={<Editparentcontact />}
                  />
                  <Route path="/GSPdf" element={<GSPdf />} />
                  <Route
                    // path="/BatchReconciliation/BRRForm"
                    path="/Secondarylistview/:accessID1/SOPDocuments/:SOPID/EditSOPDocuments/:SOPDOCID/E"
                    element={<BRRForm />}
                  />

                  {/* SOP DOCUMENT LIST */}
                  <Route
                    path="/Secondarylistview/:accessID/SopDocument/:parentID1"
                    element={<ListviewSecondary />}
                  />
                  {/* EDIT SOP DOCUMENT */}
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:parentID1/EditSopDocument/:id/:Mode"
                    element={<EditSOPDocument />}
                  />
                  {/* SOP BOOKLET LIST */}
                  <Route
                    path="/Secondarylistview/:accessID1/SopDocument/:parentID1/Booklet/:accessID/:parentID2"
                    element={<ListviewSecondary />}
                  />
                  {/* SOP DOCUMENT LIST - TR335 */}
                  <Route
                    path="/Secondarylistview/:accessID2/SopDocument/:parentID1/Booklet/:accessID1/:parentID2/SOPBatch/:accessID/:parentID3"
                    element={<ListviewSecondary />}
                  />
                  {/* SOP DOCUMENT LIST - TR335 TIMELINE */}
                  <Route
                    path="/Secondarylistview/:accessID2/SopDocument/:parentID1/Booklet/:accessID1/:parentID2/SOPBatch/:accessID/:parentID3/TimeLine/:id"
                    element={<BatchTimeLine />}
                  />
                  {/* SOP CHECKLIST LIST */}
                  <Route
                    path="/Secondarylistview/:accessID1/SopDocument/:parentID1/SopCheckList/:accessID/:parentID2"
                    element={<ListviewSecondary />}
                  />
                  {/* EDIT BOOKLET */}
                  <Route
                    path="/Secondarylistview/:accessID1/SopDocument/:parentID1/Booklet/:accessID/:parentID2/EditBooklet/:id/:Mode"
                    element={<EditBooklet />}
                  />
                  {/* EDIT CHECKLIST */}
                  <Route
                    path="/Secondarylistview/:accessID1/SopDocument/:parentID1/SopCheckList/:accessID/:parentID2/EditSopCheckList/:id/:Mode"
                    element={<EditSopCheckList />}
                  />
                  {/* EDIT ANNEXURE FORM 1 */}
                  <Route
                    path="/Secondarylistview/AnnexureForm1"
                    element={<AnnexureForm1 />}
                  />
                  <Route
                    path="/TeacherOccupancy/:id"
                    element={<TeacherOccupancy />}
                  />
                  {/* EDIT ANNEXURE FORM 2 */}
                  <Route
                    path="/Secondarylistview/AnnexureForm2"
                    element={<AnnexureForm2 />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:YearID/:filtertype/EditTimeTable/:id/:Mode"
                    element={<EditTimetablev1 />}
                  />
                  <Route
                    path="/Secondarylistview/:accessID/:screenName/:YearID/:filtertype/ProjectTimeTable"
                    element={<ProjectTimeTable />}
                  />
                  <Route
                    // path="/:accessID/RaiseComplaints"
                    path="/:accessID/RaiseComplaints/EditRaiseComplaints/:id/:Mode"
                    element={<RaiseComplaints />}
                  />
                  {/* /Apps/Secondarylistview/TR396/Debit/5/EditDebit/-1/A */}
                   <Route
                    path="/Secondarylistview/:accessID/:screenName/:type/EditDebit/:id/:Mode"
                    element={<Editdebitcash />}
                  />
                  {/* /Apps/Secondarylistview/TR395/Cash%20Management%20Category/T/Debit/8/DB/EditDebit/-1/A*/}
                   <Route
                    path="/Secondarylistview/:accessID/:screenName/:type/EditDeposit/:id/:Mode"
                    element={<Editdepositcash />}
                  /> 
                  
                  {/* <Route path="/ChangeyourPassword_1" element={<ChangeyourPassword_1 />} /> */}
                  {/* <Route path="/Geo configuration" element={<Geoconfiguration />} /> */}
                  {/* /Apps/Secondarylistview/TR303/Leader/68/EditLeader/-1/A */}
                  {/* <Route
                   path="/:accessID/:screenName/EditStageweightage/:id/:Mode"
                    element={<EditStageweightage />}
                  />
                  <Route
                   path="/:accessID/:screenName/Editactivityweightage/:id/:Mode"
                    element={<Editactivityweightage />}
                  />
                   <Route
                   path="/:accessID/:screenName/EditTaskweightage/:id/:Mode"
                    element={<EditTaskweightage />}
                  />
                  <Route
                   path="/:accessID/:screenName/EditTaskDetailweightage/:id/:Mode"
                    element={<EditTaskDetweightage />}
                  /> */}
                </Routes>
              </main>
            </div>
          </MyProSidebarProvider>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
